export default "assets/images/icons/clock-00f8bc5b.svg";